import store from 'store'
import { SET_STATE, UPDATE_AVAILABLE, UPDATE_SUCCESS } from './actions'

const STORED_SETTINGS = storedSettings => {
  const settings = {}
  Object.keys(storedSettings).forEach(key => {
    const item = store.get(`app.settings.${key}`)
    settings[key] = typeof item !== 'undefined' ? item : storedSettings[key]
  })
  return settings
}

const initialState = {
  ...STORED_SETTINGS({
    isMobileView: false,
    isMobileMenuOpen: false,
    isLightTheme: true,
    isSettingsOpen: false,
    isMenuCollapsed: false,
    isBorderless: true,
    isSquaredBorders: false,
    isFixedWidth: false,
    isMenuShadow: false,
    hasUpdate: false,
    version: '',
    locale: 'en-US',
  }),
}

export default function userReducer(state = initialState, action) {
  switch (action.type) {
    case SET_STATE:
      return { ...state, ...action.payload }
    case UPDATE_AVAILABLE:
      return {
        ...state,
        hasUpdate: true,
      }
    case UPDATE_SUCCESS:
      return {
        ...state,
        hasUpdate: false,
      }
    default:
      return state
  }
}
